import { useEffect } from "react";
import { supabase } from "./supabaseClient"; // Your Supabase client
import { useNavigate } from "react-router-dom";

const CompleteSignupInvited = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleAuthRedirect = async () => {
      const url = new URL(window.location.href);
      const params = new URLSearchParams(url.hash.substring(1)); // Remove the leading "#" and parse

      const accessToken = params.get("access_token");
      const refreshToken = params.get("refresh_token");

      console.log("Access Token:", accessToken);
      console.log("Refresh Token:", refreshToken);

      if (accessToken && refreshToken) {
        // Use Supabase's setSession function to restore the session with the tokens
        const { error: sessionError } = await supabase.auth.setSession({
          access_token: accessToken,
          refresh_token: refreshToken,
        });

        if (sessionError) {
          console.error("Error setting session:", sessionError.message);
        } else {
          // Fetch user data from Supabase
          const {
            data: { user },
            error: fetchError,
          } = await supabase.auth.getUser();

          if (fetchError) {
            console.error("Error fetching user:", fetchError.message);
          } else if (user) {
            console.log("User data:", user); // Log the full user object

            // Pass the entire user metadata to the next page
            // The destination page can retrieve it via `useLocation().state`
            navigate("/grow/invited", {
              state: {
                user: user,
              },
            });
          }
        }
      } else {
        console.error("Access token or refresh token missing from URL");
      }
    };

    handleAuthRedirect();
  }, [navigate]);

  return <div>Redirecting...</div>;
};

export default CompleteSignupInvited;
